<template>
  <div style="">
    <div>
      <el-tabs v-model="activeTab" @tab-click="handleClick">
        <el-tab-pane :label="$t('failure.faultStats')" name="stats">
          <FailureStats></FailureStats>
        </el-tab-pane>
        <el-tab-pane :label="$t('failure.faultDetail')" name="detail">
          <FailureDetail :isDetail="isDetail"></FailureDetail>
        </el-tab-pane>
      </el-tabs>

    </div>
  </div>

</template>

<script>
import FailureStats from "./failureStats.vue"
import FailureDetail from "./failureDetail.vue"
// import i18n from '@/languages' // internationalization
import settings from "@/settings";
export default {
  // name:i18n.t("failure.fault"),
  name: "failuredata",
  components: {
    FailureStats,
    FailureDetail
  },

  data() {
    return {
      activeTab: "stats",
      isDetail: false,
    };

  },

  computed: {



  },
  mounted() {
    const currentPath = this.$route.path
    // 从全局变量中取出对应路由的开始时间
    const startTime = settings.routeStartTime[currentPath]
    if (startTime) {
      // 计算耗时（mounted时组件已挂载到DOM，UI基础展示完成）
      const renderTime = Date.now() - startTime
      console.log(`路由 ${currentPath} 渲染耗时：${renderTime}ms`)
      // 可选：上报到后端或日志系统
      // reportRenderTime(currentPath, renderTime)

      // 清除已计算的开始时间，避免重复计算
      delete settings.routeStartTime[currentPath]
    }
  },
  watch: {
  },

  methods: {
    // tab点击事件
    handleClick(tabs) {
      const { index } = tabs;
      console.log(index);
      switch (index) {
        case "1":
          this.isDetail = true;
          break;
      }
      this.$nextTick(function () {
        var myEvent = new Event("resize");
        window.dispatchEvent(myEvent);
      });
    },
  }
}
</script>

<style lang="scss" scoped></style>